<template>
  <svg
    width="18px"
    height="20px"
    viewBox="0 0 18 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Tables/Extended-Tables/Simple-Table/Row-1"
        transform="translate(-1503, -13)"
        fill="#359685"
        fill-rule="nonzero"
      >
        <g
          id="content_paste_FILL1_wght400_GRAD0_opsz24"
          transform="translate(1503, 13)"
        >
          <path
            id="Shape"
            d="M2,20 C1.45,20 0.979166667,19.8041667 0.5875,19.4125 C0.195833333,19.0208333 0,18.55 0,18 L0,4 C0,3.45 0.195833333,2.97916667 0.5875,2.5875 C0.979166667,2.19583333 1.45,2 2,2 L6.175,2 C6.35833333,1.41666667 6.71666667,0.9375 7.25,0.5625 C7.78333333,0.1875 8.36666667,0 9,0 C9.66666667,0 10.2625,0.1875 10.7875,0.5625 C11.3125,0.9375 11.6666667,1.41666667 11.85,2 L16,2 C16.55,2 17.0208333,2.19583333 17.4125,2.5875 C17.8041667,2.97916667 18,3.45 18,4 L18,18 C18,18.55 17.8041667,19.0208333 17.4125,19.4125 C17.0208333,19.8041667 16.55,20 16,20 L2,20 Z M2,18 L16,18 L16,4 L14,4 L14,7 L4,7 L4,4 L2,4 L2,18 Z M9,4 C9.28333333,4 9.52083333,3.90416667 9.7125,3.7125 C9.90416667,3.52083333 10,3.28333333 10,3 C10,2.71666667 9.90416667,2.47916667 9.7125,2.2875 C9.52083333,2.09583333 9.28333333,2 9,2 C8.71666667,2 8.47916667,2.09583333 8.2875,2.2875 C8.09583333,2.47916667 8,2.71666667 8,3 C8,3.28333333 8.09583333,3.52083333 8.2875,3.7125 C8.47916667,3.90416667 8.71666667,4 9,4 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
